var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "otherinformation"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.expanded == false) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Expand All"
    },
    on: {
      "click": _vm.expandAll
    }
  }, [_vm._v("\n          Expand All "), _c('i', {
    staticClass: "fa fa-plus-circle"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded == true) ? _c('button', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "button",
      "title": "Collapse All"
    },
    on: {
      "click": _vm.collapseAll
    }
  }, [_vm._v("\n          Collapse All "), _c('i', {
    staticClass: "fa fa-minus-circle"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[1]),
      expression: "accordianTab[1]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientOtherInfo",
      "id": "chck1"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[1]) ? _vm._i(_vm.accordianTab[1], null) > -1 : (_vm.accordianTab[1])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(1)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[1],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[1] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[1] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 1, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck1"
    }
  }, [_vm._v("Products")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "productdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "tabindex": "1"
    }
  }, [_vm._v("Product Categories")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "multiple": true,
      "max-height": 200,
      "clearable": false,
      "options": _vm.productlist,
      "name": "productcategories",
      "id": "productcategories",
      "placeholder": "Select Applicable Categories",
      "append-to-body": true,
      "valueFormat": "object",
      "disabled": _vm.disableAllFileds
    },
    model: {
      value: (_vm.productname),
      callback: function($$v) {
        _vm.productname = $$v
      },
      expression: "productname"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.productLoading))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('productdetailsform.productcategories')),
      expression: "errors.has('productdetailsform.productcategories')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Product Categories field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Nature of Goods")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" \n                    "), _c('b-input-group', [_c('div', {
    staticClass: "form-group row checkbox"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.natureofgoods),
      expression: "natureofgoods"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Commercial",
      "name": "natureofgoods",
      "value": "Commercial",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.natureofgoods) ? _vm._i(_vm.natureofgoods, "Commercial") > -1 : (_vm.natureofgoods)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.natureofgoods,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Commercial",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.natureofgoods = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.natureofgoods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.natureofgoods = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "2",
      "for": "Commercial"
    }
  }, [_vm._v("Commercial")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.natureofgoods),
      expression: "natureofgoods"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Non-commercial",
      "name": "natureofgoods",
      "value": "Non-commercial",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.natureofgoods) ? _vm._i(_vm.natureofgoods, "Non-commercial") > -1 : (_vm.natureofgoods)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.natureofgoods,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Non-commercial",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.natureofgoods = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.natureofgoods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.natureofgoods = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    staticStyle: {
      "margin-right": "-18px"
    },
    attrs: {
      "tabindex": "3",
      "for": "Non-commercial"
    }
  }, [_vm._v("Non-commercial")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.natureofgoods),
      expression: "natureofgoods"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Household",
      "name": "natureofgoods",
      "value": "Household",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.natureofgoods) ? _vm._i(_vm.natureofgoods, "Household") > -1 : (_vm.natureofgoods)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.natureofgoods,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Household",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.natureofgoods = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.natureofgoods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.natureofgoods = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "4",
      "for": "Household"
    }
  }, [_vm._v("Household")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.natureofgoods),
      expression: "natureofgoods"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Others",
      "name": "natureofgoods",
      "value": "Others",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.natureofgoods) ? _vm._i(_vm.natureofgoods, "Others") > -1 : (_vm.natureofgoods)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.natureofgoods,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Others",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.natureofgoods = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.natureofgoods = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.natureofgoods = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "5",
      "for": "Others"
    }
  }, [_vm._v("Others")])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('productdetailsform.natureofgoods')),
      expression: "errors.has('productdetailsform.natureofgoods')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Nature of Goods field is required")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Average Shipment Weight (kg)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentweight),
      expression: "shipmentweight"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "min": "0",
      "id": "ShipmentWeight",
      "name": "ShipmentWeight",
      "placeholder": "Enter Shipment Weight",
      "tabindex": "6",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.shipmentweight)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentweight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('productdetailsform.ShipmentWeight')),
      expression: "errors.has('productdetailsform.ShipmentWeight')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Average Shipment Weight field is required")])], 1), _vm._v(" "), (_vm.productname && _vm.productname.some(function (item) { return item['label'] === 'Miscellaneous'; })) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Describe Miscellaneous")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.productdescription),
      expression: "productdescription"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ProductDescription",
      "name": "ProductDescription",
      "placeholder": "Enter description",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.productdescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productdescription = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('productdetailsform.ProductDescription')),
      expression: "errors.has('productdetailsform.ProductDescription')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("Miscellaneous description is required")])]) : _vm._e(), _vm._v(" "), (_vm.natureofgoods.includes('Others')) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Describe Other")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.othernatureofgoods),
      expression: "othernatureofgoods"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "Describe",
      "name": "Describe",
      "placeholder": "Enter description",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.othernatureofgoods)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.othernatureofgoods = $event.target.value
      }
    }
  })]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[2]),
      expression: "accordianTab[2]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientOtherInfo",
      "id": "chck2"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[2]) ? _vm._i(_vm.accordianTab[2], null) > -1 : (_vm.accordianTab[2])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(2)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[2],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[2] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[2] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 2, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck2"
    }
  }, [_vm._v("Safety")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "saftydetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Damage Risk:")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.damagerisk),
      expression: "damagerisk"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "damagerisk",
      "id": "HighRisk",
      "value": "1",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.damagerisk, "1")
    },
    on: {
      "__c": function($event) {
        _vm.damagerisk = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "7",
      "for": "HighRisk"
    }
  }, [_vm._v("High")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.damagerisk),
      expression: "damagerisk"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "id": "LowRisk",
      "name": "damagerisk",
      "value": "2",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.damagerisk, "2")
    },
    on: {
      "__c": function($event) {
        _vm.damagerisk = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "8",
      "for": "LowRisk"
    }
  }, [_vm._v("Low")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saftydetailsform.damagerisk')),
      expression: "errors.has('saftydetailsform.damagerisk')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Damage Risk field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "1px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isproductfragile),
      expression: "isproductfragile"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Isproductfragile",
      "value": "Isproductfragile",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.isproductfragile) ? _vm._i(_vm.isproductfragile, "Isproductfragile") > -1 : (_vm.isproductfragile)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isproductfragile,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Isproductfragile",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isproductfragile = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isproductfragile = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isproductfragile = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "9",
      "for": "Isproductfragile"
    }
  }, [_vm._v("Is product fragile ?")]), _vm._v("\n                          "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isproductliquid),
      expression: "isproductliquid"
    }],
    attrs: {
      "type": "checkbox",
      "id": "Isproductliquid",
      "value": "Isproductliquid",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.isproductliquid) ? _vm._i(_vm.isproductliquid, "Isproductliquid") > -1 : (_vm.isproductliquid)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.isproductliquid,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Isproductliquid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isproductliquid = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.isproductliquid = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isproductliquid = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "10",
      "for": "Isproductliquid"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab1(2)
      }
    }
  }, [_vm._v("Is product liquid ?")])])])], 1), _vm._v(" "), (_vm.isproductliquid == true) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Flash Point (Celsius)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]) : _vm._e(), _vm._v(" "), (_vm.isproductliquid == true) ? _c('div', {
    staticClass: "col-md-2 test"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.isproductliquid == true ? 'required' : ''))),
      expression: "`${isproductliquid == true ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.flashpoint),
      expression: "flashpoint"
    }],
    staticClass: "form-control effect-1",
    attrs: {
      "type": "text",
      "min": "0",
      "id": "FlashPoint",
      "name": "FlashPoint",
      "placeholder": "Enter Flash Point",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.flashpoint)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flashpoint = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('saftydetailsform.FlashPoint')),
      expression: "errors.has('saftydetailsform.FlashPoint')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Flash Point field is required")])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[3]),
      expression: "accordianTab[3]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientOtherInfo",
      "id": "chck3"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[3]) ? _vm._i(_vm.accordianTab[3], null) > -1 : (_vm.accordianTab[3])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(3)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[3],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[3] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[3] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 3, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck3"
    }
  }, [_vm._v("Security")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "securitydetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Product Value per kg (INR)")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-rupee'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.productvalue),
      expression: "productvalue"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "11",
      "type": "text",
      "min": "0",
      "id": "ProductValue",
      "name": "ProductValue",
      "placeholder": "Enter Value",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.productvalue)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.productvalue = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('securitydetailsform.ProductValue')),
      expression: "errors.has('securitydetailsform.ProductValue')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Product Value per kg field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Risk of theft/pilferage")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.riskoftheft),
      expression: "riskoftheft"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "riskoftheft",
      "id": "high",
      "value": "1",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.riskoftheft, "1")
    },
    on: {
      "__c": function($event) {
        _vm.riskoftheft = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "12",
      "for": "High"
    }
  }, [_vm._v("High")]), _vm._v("\n                           "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.riskoftheft),
      expression: "riskoftheft"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "riskoftheft",
      "id": "medium",
      "value": "2",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.riskoftheft, "2")
    },
    on: {
      "__c": function($event) {
        _vm.riskoftheft = "2"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "13",
      "for": "Medium"
    }
  }, [_vm._v("Medium")]), _vm._v("\n                           "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.riskoftheft),
      expression: "riskoftheft"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "riskoftheft",
      "id": "low",
      "value": "3",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.riskoftheft, "3")
    },
    on: {
      "__c": function($event) {
        _vm.riskoftheft = "3"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "14",
      "for": "Low"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab2(3)
      }
    }
  }, [_vm._v("Low")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('securitydetailsform.riskoftheft')),
      expression: "errors.has('securitydetailsform.riskoftheft')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Risk of theft/pilferage field is required")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[4]),
      expression: "accordianTab[4]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientOtherInfo",
      "id": "chck4"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[4]) ? _vm._i(_vm.accordianTab[4], null) > -1 : (_vm.accordianTab[4])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(4)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[4],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[4] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[4] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 4, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck4"
    }
  }, [_vm._v("Box Data")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "boxdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_vm._v("Preferred UOM for box dimensions")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v("    \n                          "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uom),
      expression: "uom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "uom",
      "id": "centimeter",
      "value": "cm",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.uom, "cm")
    },
    on: {
      "__c": function($event) {
        _vm.uom = "cm"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "15",
      "for": "centimeter"
    }
  }, [_vm._v("Centimeter (cm.)")]), _vm._v("\n                             "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uom),
      expression: "uom"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "uom",
      "id": "inch",
      "value": "in",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.uom, "in")
    },
    on: {
      "__c": function($event) {
        _vm.uom = "in"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "16",
      "for": "inch"
    }
  }, [_vm._v("Inch (in.)")]), _vm._v("\n                             "), _c('label', [_vm._v("(1 in. = 2.54 cm.)")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxdetailsform.uom')),
      expression: "errors.has('boxdetailsform.uom')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Preferred UOM for box dimensions")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('span', {
    staticStyle: {
      "text-decoration-line": "underline",
      "cursor": "pointer",
      "color": "blue"
    },
    on: {
      "click": _vm.openConverter
    }
  }, [_vm._v("Convert Inches to Centimeter")])])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "md"
    },
    on: {
      "ok": function($event) {
        _vm.convertermodal = false
      }
    },
    model: {
      value: (_vm.convertermodal),
      callback: function($$v) {
        _vm.convertermodal = $$v
      },
      expression: "convertermodal"
    }
  }, [_c('b-card', [_c('label', [_c('b', [_vm._v("Enter a value and press Enter")])]), _vm._v(" "), _c('div', {
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Convert Inches to Centimeter:")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeConverter
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Inches")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inches),
      expression: "inches"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "inches",
      "name": "inches",
      "placeholder": "inch"
    },
    domProps: {
      "value": (_vm.inches)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "change": function($event) {
        _vm.inchtocm()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inches = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Centimeters")]), _vm._v(" "), _c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cm),
      expression: "cm"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "cm",
      "name": "cm",
      "placeholder": "cm"
    },
    domProps: {
      "value": (_vm.cm)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "change": function($event) {
        _vm.cmtoinch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cm = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "button",
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.closeConverter()
      }
    }
  }, [_vm._v("Close")])])])], 1), _vm._v(" "), _c('b-form-fieldset', [_c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "max-height": "300px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "padding-top": "1px",
      "padding-bottom": "1px"
    }
  }, [_c('thead', {
    staticClass: "th"
  }, [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Box Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Stacking Level")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Box Strength")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("Dimensions (cm)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("Avg Physical Wt (kg)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("HSN Code")]), _vm._v(" "), (_vm.disableAllFileds != true) ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]) : _vm._e()])]), _vm._v(" "), _c('tbody', _vm._l((_vm.addBoxDimestion), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('b-input-group', [_c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: data.error
        }),
        expression: "{required: data.error}"
      }],
      attrs: {
        "tabindex": "17",
        "type": "text",
        "placeholder": "Enter Product",
        "name": _vm.setname(index, 'Product'),
        "id": _vm.setname(index, 'Product'),
        "disabled": _vm.disableAllFileds == true
      },
      on: {
        "change": function($event) {
          _vm.checkProductField(index)
        }
      },
      model: {
        value: (data.product),
        callback: function($$v) {
          data.product = $$v
        },
        expression: "data.product"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('boxdetailsform.Product' + index)),
        expression: "errors.has('boxdetailsform.Product'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select Product")])], 1), _vm._v(" "), _c('td', [_c('treeselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: data.error
        }),
        expression: "{required: data.error}"
      }],
      attrs: {
        "tabindex": "18",
        "multiple": false,
        "max-height": 200,
        "clearable": false,
        "options": _vm.boxTypesData,
        "name": _vm.setname(index, 'BoxType'),
        "id": _vm.setname(index, 'BoxType'),
        "placeholder": "Select Box Type",
        "append-to-body": true,
        "disabled": _vm.disableAllFileds
      },
      on: {
        "input": function($event) {
          _vm.checkBoxType(index)
        }
      },
      model: {
        value: (data.boxtype),
        callback: function($$v) {
          data.boxtype = $$v
        },
        expression: "data.boxtype"
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('boxdetailsform.BoxType' + index)),
        expression: "errors.has('boxdetailsform.BoxType'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please select Box Type")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.stackinglevel) + "\n                          "), _c('b-input-group', [_c('b-form-input', {
      attrs: {
        "tabindex": "19",
        "type": "hidden",
        "placeholder": "Enter Level",
        "disabled": true
      },
      model: {
        value: (data.stackinglevel),
        callback: function($$v) {
          data.stackinglevel = $$v
        },
        expression: "data.stackinglevel"
      }
    })], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.boxstrength) + "\n                          "), _c('b-input-group', [_c('b-form-input', {
      attrs: {
        "tabindex": "20",
        "type": "hidden",
        "placeholder": "Enter Strength",
        "disabled": true
      },
      model: {
        value: (data.boxstrength),
        callback: function($$v) {
          data.boxstrength = $$v
        },
        expression: "data.boxstrength"
      }
    })], 1)], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_vm._v("  \n                            "), _c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.length),
        expression: "data.length"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: data.error
        }),
        expression: "{required: data.error}"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "21",
        "type": "text",
        "min": "0",
        "id": "length",
        "name": _vm.setname(index, 'dimension'),
        "placeholder": "L",
        "disabled": _vm.disableAllFileds == true
      },
      domProps: {
        "value": (data.length)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "change": function($event) {
          _vm.checkProductField(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.length = $event.target.value
        }
      }
    })]), _vm._v("  \n                            "), _c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.breadth),
        expression: "data.breadth"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: data.error
        }),
        expression: "{required: data.error}"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "22",
        "type": "text",
        "min": "0",
        "id": "breadth",
        "name": _vm.setname(index, 'dimension'),
        "placeholder": "B",
        "disabled": _vm.disableAllFileds == true
      },
      domProps: {
        "value": (data.breadth)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "change": function($event) {
          _vm.checkProductField(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.breadth = $event.target.value
        }
      }
    })]), _vm._v("  \n                            "), _c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.height),
        expression: "data.height"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: data.error
        }),
        expression: "{required: data.error}"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "23",
        "type": "text",
        "min": "0",
        "id": "height",
        "name": _vm.setname(index, 'dimension'),
        "placeholder": "H",
        "disabled": _vm.disableAllFileds == true
      },
      domProps: {
        "value": (data.height)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "change": function($event) {
          _vm.checkProductField(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.height = $event.target.value
        }
      }
    })])], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('boxdetailsform.dimension' + index)),
        expression: "errors.has('boxdetailsform.dimension'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please enter Dimensions")])], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.physicalweight),
        expression: "data.physicalweight"
      }, {
        name: "validate",
        rawName: "v-validate"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "24",
        "type": "text",
        "min": "0",
        "name": _vm.setname(index, 'physicalweight'),
        "id": _vm.setname(index, 'physicalweight'),
        "placeholder": "Enter Weight",
        "disabled": _vm.disableAllFileds == true
      },
      domProps: {
        "value": (data.physicalweight)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.physicalweight = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('boxdetailsform.physicalweight' + index)),
        expression: "errors.has('boxdetailsform.physicalweight'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please enter Physical Wt")])], 1), _vm._v(" "), _c('td', [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.hsn),
        expression: "data.hsn"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: data.error
        }),
        expression: "{required: data.error}"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "25",
        "type": "text",
        "min": "0",
        "name": _vm.setname(index, 'HSN'),
        "id": _vm.setname(index, 'HSN'),
        "placeholder": "Enter HSN",
        "disabled": _vm.disableAllFileds == true
      },
      domProps: {
        "value": (data.hsn)
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
          _vm.handleTab3(4)
        },
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "change": function($event) {
          _vm.checkProductField(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.hsn = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('boxdetailsform.HSN' + index)),
        expression: "errors.has('boxdetailsform.HSN'+index)"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please enter HSN")])], 1), _vm._v(" "), (_vm.disableAllFileds != true) ? _c('td', {
      staticClass: "text-center"
    }, [((index + 1) == _vm.addBoxDimestion.length) ? _c('i', {
      staticClass: "fa fa-plus-circle fa-2x",
      staticStyle: {
        "color": "blue",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addNewRow(index)
        }
      }
    }) : _vm._e(), _vm._v(" "), ((index + 1) < _vm.addBoxDimestion.length) ? _c('i', {
      staticClass: "fa fa-trash fa-2x",
      staticStyle: {
        "color": "red",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.deleteRow(index)
        }
      }
    }) : _vm._e()]) : _vm._e()])
  }))])]), _vm._v(" "), (_vm.disableAllFileds != true) ? _c('div', {
    staticClass: "file-upload",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('label', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "for": "uploadBoxData"
    }
  }, [_c('a', {
    staticClass: "-btn btn-primary"
  }, [_vm._v("Upload Data (.XLSX) "), _c('i', {
    staticClass: "fa fa-upload"
  })])]), _vm._v(" "), _c('a', {
    staticClass: "-btn btn-primary",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "../static/Sample_Box_Data.xlsx",
      "target": "_blank"
    }
  }, [_vm._v("Download Data/ Template (.XLSX) "), _c('i', {
    staticClass: "fa fa-download"
  })]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "id": "uploadBoxData",
      "name": "uploadBoxData",
      "type": "file"
    },
    on: {
      "change": _vm.uploadBoxData
    }
  })]) : _vm._e()])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[5]),
      expression: "accordianTab[5]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientOtherInfo",
      "id": "chck5"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[5]) ? _vm._i(_vm.accordianTab[5], null) > -1 : (_vm.accordianTab[5])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(5)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[5],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[5] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[5] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 5, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck5"
    }
  }, [_vm._v("Commercial Projections")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "commercialdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table-bordered tableBodyScroll"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.ProjectedSalesData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(data.month))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "200px"
      }
    }, [_vm._v(_vm._s(data.year))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (data.projectedsales),
        expression: "data.projectedsales"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      attrs: {
        "tabindex": "26",
        "type": "text",
        "min": "0",
        "name": _vm.setname(index, 'ProjectedSales'),
        "id": _vm.setname(index, 'ProjectedSales'),
        "placeholder": "Enter Projected Sales",
        "disabled": _vm.disableAllFileds == true
      },
      domProps: {
        "value": (data.projectedsales)
      },
      on: {
        "keypress": function($event) {
          _vm.isNumber($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          data.projectedsales = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('commercialdetailsform.ProjectedSales' + index)),
        expression: "errors.has('commercialdetailsform.ProjectedSales'+index)"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("The Projected Sales field is required")])], 1)])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Expected Yield per kg")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.expectedyield),
      expression: "expectedyield"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "tabindex": "27",
      "type": "text",
      "min": "0",
      "id": "ExpectedYield",
      "name": "ExpectedYield",
      "placeholder": "Enter Expected Yield",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.expectedyield)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab4(5)
      },
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.expectedyield = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('commercialdetailsform.ExpectedYield')),
      expression: "errors.has('commercialdetailsform.ExpectedYield')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Expected Yield per kg field is required")])], 1)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "radio"
  }, [_c('label', [_vm._v("Annual Contract Revision")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v("    \n                          "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annualcontractrevision),
      expression: "annualcontractrevision"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "annualcontractrevision",
      "id": "revisionyes",
      "value": "1",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.annualcontractrevision, "1")
    },
    on: {
      "__c": function($event) {
        _vm.annualcontractrevision = "1"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "15",
      "for": "revisionyes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annualcontractrevision),
      expression: "annualcontractrevision"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "annualcontractrevision",
      "id": "revisionno",
      "value": "0",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": _vm._q(_vm.annualcontractrevision, "0")
    },
    on: {
      "__c": function($event) {
        _vm.annualcontractrevision = "0"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', {
    attrs: {
      "tabindex": "16",
      "for": "revisionno"
    }
  }, [_vm._v("No")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxdetailsform.annualcontractrevision')),
      expression: "errors.has('boxdetailsform.annualcontractrevision')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please select Annual Contract Revision")])], 1), _vm._v(" "), (_vm.annualcontractrevision == 1) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("% Revision on Base Rate =")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]) : _vm._e(), _vm._v(" "), (_vm.annualcontractrevision == 1) ? _c('div', {
    staticClass: "col-md-2 test"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.annualcontractrevision == 1 ? 'required' : ''))),
      expression: "`${annualcontractrevision == 1 ? 'required' : ''}`"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.revisionpercentage),
      expression: "revisionpercentage"
    }],
    staticClass: "form-control effect-1",
    attrs: {
      "type": "text",
      "min": "0",
      "id": "revisionpercentage",
      "name": "RevisionPercentage",
      "placeholder": "Enter Revision Percentage",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "value": (_vm.revisionpercentage)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.revisionpercentage = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('boxdetailsform.RevisionPercentage')),
      expression: "errors.has('boxdetailsform.RevisionPercentage')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Revision Percentage field is required")])], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[6]),
      expression: "accordianTab[6]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "ClientOtherInfo",
      "id": "chck6"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[6]) ? _vm._i(_vm.accordianTab[6], null) > -1 : (_vm.accordianTab[6])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(6)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[6],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[6] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[6] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 6, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck6"
    }
  }, [_vm._v("Manifest Data Upload Method")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "menifestdetailsform"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 checkbox"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "1px",
      "padding-bottom": "1px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "checkbox",
      "name": "uploadmethod",
      "id": "APIIntegration",
      "value": "APIIntegration",
      "disabled": _vm.disableAllFileds == true || _vm.isfranchisee == 1
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "APIIntegration") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "APIIntegration",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)]), _c('label', {
    attrs: {
      "tabindex": "28",
      "for": "APIIntegration"
    }
  }, [_vm._v("API Integration")])]), _vm._v(" "), (_vm.isfranchisee == 0) ? _c('div', {
    staticClass: "col-md-4 checkbox"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "1px",
      "padding-bottom": "1px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "name": "uploadmethod",
      "id": "SoftDataUpload",
      "value": "SoftDataUpload",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "SoftDataUpload") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "SoftDataUpload",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(3)]), _c('label', {
    attrs: {
      "tabindex": "29",
      "for": "SoftDataUpload"
    }
  }, [_vm._v("Soft Data Upload")])]) : _vm._e(), _vm._v(" "), (_vm.isfranchisee == 0) ? _c('div', {
    staticClass: "col-md-4 checkbox"
  }, [_c('label', {
    staticStyle: {
      "padding-top": "1px",
      "padding-bottom": "1px"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.checkedNames),
      expression: "checkedNames"
    }],
    attrs: {
      "type": "checkbox",
      "name": "uploadmethod",
      "id": "ManualBooking",
      "value": "ManualBooking",
      "disabled": _vm.disableAllFileds == true
    },
    domProps: {
      "checked": Array.isArray(_vm.checkedNames) ? _vm._i(_vm.checkedNames, "ManualBooking") > -1 : (_vm.checkedNames)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.checkedNames,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "ManualBooking",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkedNames = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.checkedNames = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkedNames = $$c
        }
      }
    }
  }), _vm._v(" "), _vm._m(4)]), _c('label', {
    attrs: {
      "tabindex": "30",
      "for": "ManualBooking"
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.handleTab5(6)
      }
    }
  }, [_vm._v("Manual Booking")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('menifestdetailsform.uploadmethod')),
      expression: "errors.has('menifestdetailsform.uploadmethod')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Manifest Data Upload Method field is required")])])])])])]), _vm._v(" "), (_vm.clientOtherInfoData && _vm.clientOtherInfoData.cbid) ? _c('div', {
    staticClass: "tab"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accordianTab[7]),
      expression: "accordianTab[7]"
    }],
    attrs: {
      "type": "checkbox",
      "name": "PorttoPort",
      "id": "chck7"
    },
    domProps: {
      "checked": Array.isArray(_vm.accordianTab[7]) ? _vm._i(_vm.accordianTab[7], null) > -1 : (_vm.accordianTab[7])
    },
    on: {
      "click": function($event) {
        _vm.toggleCheck(7)
      },
      "__c": function($event) {
        var $$a = _vm.accordianTab[7],
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.accordianTab[7] = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.accordianTab[7] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.accordianTab, 7, $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "tab-label",
    attrs: {
      "for": "chck7"
    }
  }, [_vm._v("Select Port To Port Rates")]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "porttoportcategory"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "tabindex": "1"
    }
  }, [_vm._v("Select Category for Port to Port")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    class: {
      changeColor: _vm.disableAllFileds == true
    },
    attrs: {
      "left": "<i class='fa fa-gear'></i>"
    }
  }, [_c('treeselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.categoryNameList,
      "name": "categoryNameList",
      "id": "categoryNameList",
      "placeholder": "Select Applicable Categories",
      "append-to-body": true,
      "valueFormat": "object"
    },
    model: {
      value: (_vm.selectedCategory),
      callback: function($$v) {
        _vm.selectedCategory = $$v
      },
      expression: "selectedCategory"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('porttoportcategory.categoryNameList')),
      expression: "errors.has('porttoportcategory.categoryNameList')"
    }],
    staticClass: "text-danger errormsg"
  }, [_vm._v("The Categories field is required")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-1",
    staticStyle: {
      "padding-top": "40px"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveCategoryDataForPortToPort
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])])])])])]) : _vm._e()])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-body "
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientData && _vm.clientData.ClientSystemID != ''),
      expression: "clientData && clientData.ClientSystemID!= ''"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "-btn btn-warning",
    staticStyle: {
      "color": "white",
      "background-color": "#ff9800"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.approvesend == true
    },
    on: {
      "click": _vm.sendForApprove
    }
  }, [_vm._v(_vm._s(_vm.approvesend == true ? 'Approved' : 'Send For Approval') + "  "), _c('i', {
    staticClass: "fa",
    class: [_vm.approvesend == true ? 'fa-check' : 'fa-paper-plane']
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "click": _vm.saveClientOtherInformations
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disableAllFileds == true
    },
    on: {
      "click": function($event) {
        _vm.saveAndNext('saveandnext')
      }
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })])])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('strong', [_vm._v("Yearly Sales Projection (Tonnes)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b', [_vm._v("Month")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b', [_vm._v("Year")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Projected Sales (Tonnes)")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef60f702","hasScoped":true}!./src/modules/clientmanagement/views/client/addclient/otherinformation/otherinformation.html
// module id = 686
// module chunks = 3